import { render, staticRenderFns } from "./Procure.vue?vue&type=template&id=fea3a6ca&scoped=true&"
import script from "./Procure.vue?vue&type=script&lang=js&"
export * from "./Procure.vue?vue&type=script&lang=js&"
import style0 from "./Procure.vue?vue&type=style&index=0&id=fea3a6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea3a6ca",
  null
  
)

export default component.exports